import {View, Model} from 'backbone';
import eventBus         from 'EventBus.js';
import sequenceService from 'SequenceService.js';
import nameTemplate from 'report/properties/main/data-sources.ejs';
import BaseTableView from 'properties/BaseTableView.js'
import DataSourcesModalView from 'common-views/DataSourcesModalView.js'
import listService from 'ListService.js';
import util from 'util/Util.js';
import constants from 'Constants.js'; 

class MainDataSourcesView extends BaseTableView {

    initialize(opts) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.minRows = 4;
        
        this.events = {
            'click #New': 'openNewDataSourcesModal',
            'click #Edit': 'editNewDataSourcesModal',
            'click #Duplicate': 'duplicateSelectedRow',
            'click #Remove': 'removeSelectedRow'
        };

        if (!this.model.get('dataSources')) {
            let ds = listService.getDataSources();
            this.model.set('dataSources', ds.toIndexedSeq().toArray(), {silent: true})
        }

        this.model.set({
            colModel: [
                {
                    name: 'id',
                    index: 'id',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'name',
                    index: 'name',
                    editable: false
                },
                {
                    name: 'uses',
                    index: 'uses',
                    editable: false
                }
            ],
            colNames: ['Id', 'Name', 'Uses']
        },{silent:true});

        this.listenTo(this.model, 'change', this.render); 
        
        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }        

        this.onResize();
        return this;
    }

    openNewDataSourcesModal(ev) {
        util.saveGridScrollPos(this.model, '.ui-jqgrid-bdiv.ui-corner-bottom > div');
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        ev.preventDefault();
        // Creating default values for new dataSource.
        let newDataSourceData = {
            formData: {},
            formFields: [],
            formulaParameter: {},
            joinFilter: 'and',
            name: '',
            notes: ''
        };


        let DataSource = {
            id: '',
            type: 'form',
            name: '',
            description: '',
            formName: '',
            useORForDynamicFilters: 'false',
            formGUID: ''
        };
        DataSource.Fields = { Field: [] };

        // Calling the modal.
        let dataSourceModal = new DataSourcesModalView({
            model: new Model({
                //dataSourceData: newDataSourceData
                dataSourceData: DataSource
            }), mode: {isEdit: false}
        });
        dataSourceModal.render().then((dataSourceValues)=> {
            // Checking if the modal was canceled, in order to perform the addition or not.
            if (dataSourceValues !== 'Canceled') {

                dataSourceValues.id = sequenceService.nextDomId();
                dataSourceValues.uses=dataSourceValues.uses;
                listService.addDataSource( dataSourceValues );

                let ds = this.model.get('dataSources');
                ds.push(dataSourceValues);

                listService.addDependency({id: dataSourceValues.formGUID, type: dataSourceValues.type, caption: dataSourceValues.formName});

                this.render();
            }

            // Enabling table options if there is an existing element in the dataSource table.
            this.enableTableOptions();
            util.setGridScrollPos(this.model, '.ui-jqgrid-bdiv.ui-corner-bottom > div');
        }).catch(err => {
            console.log(err);
            this.enableTableOptions();
        });
    }

    enableTableOptions() {
        if ($(this.gridEl).getDataIDs().length > 0) {
            $("#Edit").prop('disabled', false);
            $("#Duplicate").prop('disabled', false);
            $("#Remove").prop('disabled', false);
        }
    }

    editNewDataSourcesModal(ev) {
        util.saveGridScrollPos(this.model, '.ui-jqgrid-bdiv.ui-corner-bottom > div');
        ev.preventDefault();
        let selectedRow = $(this.gridEl).jqGrid('getGridParam', 'selrow');
        if (selectedRow) {
            // find DataSource by ID (selectedRow)
            const ds = listService.getDataSources();
            let DataSource = $.grep(ds.toIndexedSeq().toArray() , function(e){ return e.id === selectedRow; }); 

            let _datasource = {
                id: DataSource[0].id,
                type: DataSource[0].type,
                name: DataSource[0].name,
                description: DataSource[0].description,
                formName: DataSource[0].formName,
                useORForDynamicFilters: DataSource[0].useORForDynamicFilters,
                formGUID: DataSource[0].formGUID,
                formulaParameter: DataSource[0].formulaParameter
            }

            _datasource.Fields = { Field: [] };
            _datasource.Fields.Field = DataSource[0].Fields.Field;


            //let dataSourceToWork = this.model.get('dataSources')[selectedRow];
            // Loading the data in the modal.
            let dataSourceModal = new DataSourcesModalView({
                model: new Model({dataSourceData: _datasource})
            });
            dataSourceModal.render().then((dataSourceValues)=> {
                // Checking if the modal was canceled, in order to perform the edition or not.
                if (dataSourceValues !== 'Canceled') {
                    listService.updateDataSource( dataSourceValues );
                    this.render();
                }
                this.enableTableOptions();
            }).catch(err => {
                console.log(err);
                this.enableTableOptions();
            });


        }
    }

    getNameDuplicated(name){

        let ds = this.model.get('dataSources');
        let count=2;
        let flag =false;
        let newName=name;

        while(flag===false){
            newName=name + ' ('+count+')';
            flag=true;
            $.each(ds,function(index,value){
                if(value.name === newName){
                    flag=false;
                    count++;
                    return false;
                }
            });
        }

        return newName;
    }

    duplicateSelectedRow(ev) {

        // Getting the current selected dataSource,
        // creating a new one with the same data ana adding it to the main list.
        let selectedRow = $(this.gridEl).jqGrid('getGridParam', 'selrow');
        if (selectedRow) {
            let ds = this.model.get('dataSources');
            const resultDS = $.grep(ds, function(e){ return e.id === selectedRow; });
            let finalDS =  _.clone(resultDS[0]);
            if(finalDS){
                finalDS.name=this.getNameDuplicated(finalDS.formName);
                finalDS.formName=finalDS.name;
                finalDS.id = sequenceService.nextDomId();
                listService.addDataSource(finalDS);
                ds.push(finalDS);
                this.model.set('dataSources', ds, {silent: true});//
                this.render();
                this.enableTableOptions();
            }
        }
    }

    removeSelectedRow(ev) {
        util.saveGridScrollPos(this.model, '.ui-jqgrid-bdiv.ui-corner-bottom > div');
        // Getting the current selected dataSource,
        // creating a new one with the same data and removing it to the main list.
        let selectedRow = $(this.gridEl).jqGrid('getGridParam', 'selrow');
        if (selectedRow) {

            let removedDataSources = this.model.get('dataSources');

            let position=this.findWithAttr(removedDataSources,'id',selectedRow);

            if(position >-1){
                removedDataSources.splice(position, 1);

                this.model.set('dataSources', removedDataSources, {silent: true});//

                listService.deleteDataSource( selectedRow )
                this.render();
                this.enableTableOptions();
            }

        }
    }

    findWithAttr(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }

    fillDataSourcesTable() {
        /*
        let dataSourceList = this.model.get('dataSources');
        util.deleteGridRows(this.gridEl);
        let self = this;
        if (dataSourceList.length !== 0) {
            dataSourceList.forEach(function (value, index) {
                self.fillNewRow(index, value['name'], 0)
            });
        }
        else {
            for (let i = 0; i < 3; i++) {
                self.fillNewRow(i, '', '');
            }
        }
        */
        let self = this;
        util.deleteGridRows(this.gridEl);

        const ds = listService.getDataSources();
        ds.map( (v, k) => {
            v.uses = listService.objectList.filter((v1, k1) => listService.cleanId(v1.model.get('dataSourceId')) === v.id ).size;
            self.fillNewRow(v.id, v.name, v.uses);
        });
    }

    fillNewRow(index, name, uses) {
        var newRow = {
            'id': index,
            'name': name,
            'uses': uses
        };
        $(this.gridEl).addRowData(index, newRow);
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize() {
        $(window).on('resize', this.resizeGrid);
    }

    render() {
        this.onRender();
        let gridData = this.model.get('dataSources');

        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        let self = this;
        let gridObject = util.getGridObject(self, {
            gridComplete: function () {
                $(self.gridEl + " tr.jqgrow:even").css("background", "#F5F5F5");
            }, 

            autowidth: true, 
            resizeStop: function(width, index) {
                    let columns = $(self._gridEl).jqGrid ('getGridParam', 'colModel');
                    let colWidth = columns.filter(c => !c.hidden).reduce((a, c) => a + c.width, 0);

                    if ($("#gbox_propMainTable").width() < colWidth) {
                        $(self._gridEl).closest('.ui-jqgrid-bdiv')
                            .css('overflow', '')
                            .addClass('format-table-overflow-shown');
                    }
                }
        });

        $(self.gridEl).jqGrid(gridObject);

        this.fillDataSourcesTable();
        this.resizeGrid();
        this.enableTableOptions();
        this.delegateEvents();
        this.$el.css('cursor', 'default');
        this.afterRender();
        return this;
    }

    afterRender(){
        this.addDefaultEmptyRows();
        util.setGridScrollPos(this.model, '.ui-jqgrid-bdiv.ui-corner-bottom > div');
    }

     addDefaultEmptyRows(){
        var gridDataSources = this.model.get('dataSources');
        let size = $(this.gridEl).getGridParam("reccount");
        if (size < this.minRows) {
            var newRow = {
                'id': '',
                'name': '',
                'uses': ''
            };
            
            for (let i=size; i<this.minRows; ++i) {
                $(this.gridEl).addRowData((gridDataSources.length + 1), newRow);
            }
        }
        if(size > this.minRows){
            $(this.gridEl).parent('div').css({'height':'70px','overflow-x':'hidden'});
        }
    }

    remove(){
         $(window).unbind('resize', this.resizeGrid);
         super.remove();
    }
}

export default MainDataSourcesView;
